<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="element-box">
        <CoachingOverviewData
            :coaching="coachingData"
            :calculatedUnits="calculatedUnitsData"/>

        <Menu :coaching="coachingData"
              :currentUser="piniaCurrentUser"/>

        <transition name="fade">
          <div class="row" v-if="unitsErrorMessage">
            <div class="col-12">
              <div style="
                color: #e65252;
                font-size: 16px;
                padding: 10px;
                background: #F8F8F8;
                border: 1px solid #e65252;
                margin-bottom: 20px;
                border-radius: 3px">
                {{ unitsErrorMessage }}
              </div>
            </div>
          </div>
        </transition>

        <div v-if="showUpdateAsAdminButton" class="row mb-5" style="border-bottom: 1px solid #D8D8D8">
          <div class="col text-end" style="font-size: 17px;">{{ $t('general.update_as_admin') }}</div>
          <div class="col-auto text-end">
            <BaseToggle v-model="updateAsAdmin" @change="onChangeUpdateAsAdmin"/>
          </div>
        </div>

        <form @submit.prevent="submitForm" novalidate class="mt-4">
          <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-6 col-12  ">
              <Datepicker
                  v-model="formData.termin"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  label="Termin"
                  position="down"
                  :validation="v$.termin"
                  :messages="v$.termin.required.$message"/>
            </div>
            <div class="col-lg-4 col-md-8 col-sm-12  ">
              <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      v-model="formData.startTime"
                      :key="startTimeKey"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :minutesArray=minutesArray
                      label="Startzeit"/>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                  <Timepicker
                      v-model="formData.endTime"
                      :key="endTimeKey"
                      :disabled="isBilled || isCoachBilled"
                      :required="true"
                      :minutesArray=minutesArray
                      label="Endzeit"/>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <SelectVue v-model="formData.presence"
                         :options="presenceDropdown"
                         :disabled="isBilled || isCoachBilled"
                         :required="true"
                         :is-clear="true"
                         label="Anwesenheit"
                         placeholder="Wählen Sie Anwesenheit"
                         :validation="v$.presence"
                         :messages="v$.presence.required.$message"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseNumber
                  v-model="formData.units"
                  :labelStyle="labelStyle"
                  label="Fachleistungsstunden"
                  disabled="disabled"/>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-12">
              <BaseNumber
                  v-model="formData.totalMinutes"
                  :labelStyle="labelStyle"
                  label="in Minuten"
                  disabled="disabled"/>
            </div>
            <div class="col-6 col-lg-2 col-md-4">
              <div class="mt-4">
                <BaseCheckbox
                    v-model="formData.signature"
                    :disabled="isBilled || isCoachBilled || isDigitalSignature"
                    :validation="v$.signature"
                    label="Unterschrift"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-6 col-lg-2 col-md-4">
              <div class="mt-4"
                   v-if="
                   currentUserRole === 'ROLE_ADMIN' ||
                   currentUserRole === 'ROLE_ACCOUNTANT'">
                <BaseCheckbox
                    v-model="formData.billed"
                    :disabled="isBilled"
                    :validation="v$.billed"
                    label="Abgerechnet"
                    :labelPosition="'right'"/>
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12 mt-3 mt-sm-0">
              <SelectVue
                  v-if="
                  currentUserRole === 'ROLE_ADMIN' ||
                  currentUserRole === 'ROLE_SITE_SUPPORT' ||
                  currentUserRole === 'ROLE_SITE_MANAGER' ||
                  currentUserRole === 'ROLE_HEAD_OF_PSYCHOSOCIAL_SERVICES' ||
                  currentUserRole === 'ROLE_ACCOUNTANT'"
                  v-model="formData.coachId"
                  :options="coachDropdown"
                  :disabled="isCoachBilled"
                  :is-clear="true"
                  label="Coach"
                  placeholder="Trainer auswählen"/>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-12">
              <SelectVue
                  v-model="formData.placeAndTypeOfCare"
                  :options="placeAndTypeOfCareDropdown"
                  :disabled="isBilled || isCoachBilled"
                  :required="true"
                  label="Ort und art der betreuung"
                  :validation="v$.placeAndTypeOfCare"
                  :messages="v$.placeAndTypeOfCare.required.$message"/>
            </div>
          </div>

          <!--          <div class="row">-->
          <!--            <div class="col-lg-2 col-md-6 col-sm-12">-->
          <!--              <SelectVue-->
          <!--                  v-model="formData.appointmentType"-->
          <!--                  @update:modelValue="onUpdateAppointmentType"-->
          <!--                  :options="appointmentTypeDropdown"-->
          <!--                  :disabled="isBilled || isCoachBilled"-->
          <!--                  :required="true"-->
          <!--                  :is-clear="false"-->
          <!--                  label="Art des Termins"-->
          <!--                  :validation="v$.appointmentType"-->
          <!--                  :messages="v$.appointmentType?.required?.$message"/>-->
          <!--            </div>-->
          <!--          </div>-->

          <div class="row">
            <div class="col-12 text-end">
              <button
                  v-if="currentUserRole === 'ROLE_ADMIN' && updatedByAdmin"
                  @click.prevent="handleMeetingHistoryModal()"
                  class="btn btn-primary" style="margin-top: 28px;">
                <i class="os-icon os-icon-rotate-ccw"></i>
              </button>

              <button v-if="isDigitalSignature && firstInterviewId" class="btn btn-primary" style="margin-top: 28px;"
                      @click.prevent="handleDigitalSignatureModal()">
                Digitale Unterschrift
              </button>

              <span v-if="isDigitalSignature && missingDigitalSignatureForFirstInterview"
                    style="color: red; display: block; margin-top: 11px;">
                {{ $t('general.missing_digital_signature') }}
              </span>
            </div>
          </div>

          <div class="accordion mt-5">
            <!-- Accordion Item 1 -->
            <div class="accordion-item">
              <div class="accordion-header" @click="toggleAccordion(1)">
                <h6 :style="{ color: 'var(--primary)' }">Anamnese und Evaluationsdaten</h6>
              </div>
              <div v-if="activeAccordion === 1" class="accordion-body">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6>Zielgruppe</h6>
                    <BaseRadio
                        v-model="formDataRadioButtons.targetGroup"
                        :labelPosition="'right'"
                        name="Zielgruppe"
                        classFormGroup="mb-0  custom-radio"
                        label="Psychisch behinderte Menschen"
                        id="mentallyDisabledPeople"/>
                    <BaseRadio
                        v-model="formDataRadioButtons.targetGroup"
                        :labelPosition="'right'"
                        name="Zielgruppe"
                        classFormGroup="mb-0 custom-radio"
                        label="Menschen mit schwerwiegenden, andauernden Abhängigkeitserkrankungen"
                        id="peopleWithAddictionDisorders"/>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <h6>Betreuungsdauer (inkl. Zeiten vor dem betreuten Wohnen / jährliche Prüfung notwendig)</h6>
                  </div>
                  <div class="col-12 d-flex">
                    <BaseRadio
                        v-model="formData.durationOfSupervision"
                        label="< 3 Jahre"
                        name="durationOfSupervision"
                        id="< 3"
                        :labelPosition="'right'"
                        classFormGroup="form-check form-check-inline"/>
                    <BaseRadio
                        v-model="formData.durationOfSupervision"
                        label="3 – 5 Jahre"
                        name="durationOfSupervision"
                        id="3 - 5"
                        :labelPosition="'right'"
                        classFormGroup="form-check form-check-inline"/>
                    <BaseRadio
                        v-model="formData.durationOfSupervision"
                        label="> 5 Jahre"
                        name="durationOfSupervision"
                        id="> 5"
                        :labelPosition="'right'"
                        classFormGroup="form-check form-check-inline"/>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-12">
                    <h6>Wohnform</h6>
                  </div>
                  <div class="col-12">
                    <BaseRadio
                        v-model="formDataRadioButtons.typeOfLiving"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="singleApartment"
                        label="Einzelwohnung"/>
                    <BaseRadio
                        v-model="formDataRadioButtons.typeOfLiving"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="coupleApartment"
                        label="Paarwohnung (inkl. Familie)"/>
                    <BaseRadio
                        v-model="formDataRadioButtons.typeOfLiving"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="sharedApartment"
                        label="Wohngemeinschaft"/>
                    <BaseRadio
                        v-model="formDataRadioButtons.typeOfLiving"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="inTheFamilyOfOrigin"
                        label="In der Herkunftsfamilie"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <BaseRadio
                        v-model="formDataRadioButtons.typeOfLiving"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="housingStyleOthers"
                        label="Sonstige"/>
                  </div>
                  <div class="col-lg-10 col-md-12" v-if="formDataRadioButtons.typeOfLiving === 'housingStyleOthers'">
                    <BaseInput v-model="formData.othersDescription" :validation="v$.othersDescription"
                               :messages="v$.othersDescription.required.$message"/>
                  </div>
                </div>

                <div class="row mt-3">
                  <div class="col-12">
                    <h6>Wohnraumvermittler /-vermieter</h6>
                  </div>

                  <div class="col-12">
                    <BaseRadio
                        v-model="formDataRadioButtons.housingBroker"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="noMediation"
                        label="Keine Vermittlung"/>
                    <BaseRadio
                        v-model="formDataRadioButtons.housingBroker"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="serviceProvider"
                        label="Leistungserbringer"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <BaseRadio
                        v-model="formDataRadioButtons.housingBroker"
                        :labelPosition="'right'"
                        classFormGroup="mb-0 custom-radio"
                        id="cooperationPartner"
                        label="Kooperationspartner"/>
                  </div>
                  <div class="col-lg-10 col-md-12" v-if="formDataRadioButtons.housingBroker === 'cooperationPartner'">
                    <BaseInput v-model="formData.cooperationPartnerDescription"
                               :validation="v$.cooperationPartnerDescription"
                               :messages="v$.cooperationPartnerDescription.required.$message"/>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <CooperationPartnerAccordionItem
                        title="Kooperationspartner / Vernetzung mit anderen Diensten"
                        :items="formData.cooperationPartners"
                        @addItem="(newItem) => addItem('cooperationPartners', newItem)"
                        @deleteItem="(index) => removeItem('cooperationPartners', index)"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Accordion Item 2 -->
          <div class="accordion-item">
            <div class="accordion-header" @click="toggleAccordion(2)">
              <h6 :style="{ color: 'var(--primary)' }">Gesundheitsfragen</h6>
            </div>
            <div v-if="activeAccordion === 2" class="accordion-body">
              <AccordionItem
                  title="Einschränkung"
                  :items="formData.limitations"
                  itemTitleLabel="Gesundheitliche Einschränkung"
                  itemDescriptionLabel="Auswirkung"
                  @addItem="(newItem) => addItem('limitations', newItem)"
                  @deleteItem="(index) => removeItem('limitations', index)"/>
              <AccordionItem
                  title="Abhängigkeit"
                  :items="formData.dependencies"
                  itemTitleLabel="Art der Abhängigkeit"
                  itemDescriptionLabel="Beschreibung (Menge/Substanz)"
                  @addItem="(newItem) => addItem('dependencies', newItem)"
                  @deleteItem="(index) => removeItem('dependencies', index)"/>
              <AccordionItemWithDropdown
                  title="Ärztliche Versorgung"
                  :items="formData.medicalCares"
                  itemTitleLabel="Art der Hilfeleistung"
                  itemDescriptionLabel="Kontaktdaten"
                  :dropdownOptions="doctorTypes || []"
                  @addItem="(newItem) => addItem('medicalCares', newItem)"
                  @deleteItem="(index) => removeItem('medicalCares', index)"/>
              <AccordionItem
                  title="Medikamente"
                  :items="formData.medications"
                  itemTitleLabel="Handelsname"
                  itemDescriptionLabel="Indikation"
                  @addItem="(newItem) => addItem('medications', newItem)"
                  @deleteItem="(index) => removeItem('medications', index)"/>
              <AccordionItemWithDropdown
                  title="Weitere ambulante Behandlung und Hilfeleistung"
                  :items="formData.treatmentsAndAssistance"
                  itemTitleLabel="Art der Hilfeleistung"
                  itemDescriptionLabel="Kontaktdaten"
                  :dropdownOptions="assistanceTypes || []"
                  @addItem="(newItem) => addItem('treatmentsAndAssistance', newItem)"
                  @deleteItem="(index) => removeItem('treatmentsAndAssistance', index)"/>
              <AccordionItem
                  title="Stationäre Behandlung der letzten Jahre"
                  :items="formData.treatmentInYears"
                  itemTitleLabel="Krankenhaus"
                  itemDescriptionLabel="Beschreibung / Folgen"
                  @addItem="(newItem) => addItem('treatmentInYears', newItem)"
                  @deleteItem="(index) => removeItem('treatmentInYears', index)"/>
            </div>
          </div>

          <!-- Accordion Item 3 -->
          <div class="accordion-item">
            <div class="accordion-header" @click="toggleAccordion(3)">
              <h6 :style="{ color: 'var(--primary)' }">Ressourcen und Kompetenzen</h6>
            </div>
            <div v-if="activeAccordion === 3" class="accordion-body">
              <AccordionItem
                  title="Ressourcen und Kompetenzen"
                  :items="formData.resourceAndSkills"
                  itemTitleLabel="Ressourcen und Kompetenzen"
                  itemDescriptionLabel="Was und wie?"
                  @addItem="(newItem) => addItem('resourceAndSkills', newItem)"
                  @deleteItem="(index) => removeItem('resourceAndSkills', index)"/>
            </div>
          </div>

          <!-- Accordion Item 4 -->
          <div class="accordion-item">
            <div class="accordion-header" @click="toggleAccordion(4)">
              <h6 :style="{ color: 'var(--primary)' }">Arbeitsbiografischer Kontext</h6>
            </div>
            <div v-if="activeAccordion === 4" class="accordion-body">
              <div class="row">
                <div class="col-6">
                  <SelectVue
                      v-model="formData.graduation"
                      :options="graduationTypes || []"
                      label="Schulabschluss"
                      placeholder="Arten von Abschlüssen"/>
                </div>
                <div class="col-12 mt-4">
                  <TextEditor
                      v-model="formData.education"
                      @update:model-value="formData.education = $event"
                      :inputStyle="{ height: '200px' }"
                      label="Ausbildung"/>
                </div>
                <div class="col-12 mt-4">
                  <TextEditor
                      v-model="formData.employmentBiography"
                      @update:model-value="formData.employmentBiography = $event"
                      :inputStyle="{ height: '200px' }"
                      label="Erwerbsbiographie"/>
                </div>
                <div class="col-12 mt-4">
                  <TextEditor
                      v-model="formData.leaveTheProfession"
                      @update:model-value="formData.leaveTheProfession = $event"
                      :inputStyle="{ height: '200px' }"
                      label="Wann und wie aus dem Beruf ausgeschieden"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Accordion Item 5 -->
          <div class="accordion-item">
            <div class="accordion-header" @click="toggleAccordion(5)">
              <h6 :style="{ color: 'var(--primary)' }">Einschränkung</h6>
            </div>
            <div v-if="activeAccordion === 5" class="accordion-body">
              <AccordionItem
                  title="Einschränkung"
                  :items="formData.obstacles"
                  itemTitleLabel="Problemlage / Hemmnis"
                  itemDescriptionLabel="Beschreibung"
                  @addItem="(newItem) => addItem('obstacles', newItem)"
                  @deleteItem="(index) => removeItem('obstacles', index)"/>
              <AccordionItem
                  title="Handlungsplan"
                  :items="formData.steps"
                  itemTitleLabel="Ziel"
                  itemDescriptionLabel="Umsetzung"
                  @addItem="(newItem) => addItem('steps', newItem)"
                  @deleteItem="(index) => removeItem('steps', index)"/>
              <AccordionItemWithDropdown
                  title="Coaching"
                  :items="formData.typesOfCoaching"
                  itemTitleLabel="Art des Coachings"
                  :dropdownOptions="typesOfCoachingDropdown"
                  itemSelectPlaceholder="Coachingarten"
                  itemDescriptionLabel="Beschreibung"
                  @addItem="(newItem) => addItem('typesOfCoaching', newItem)"
                  @deleteItem="(index) => removeItem('typesOfCoaching', index)"/>
            </div>
          </div>

          <ValidationErrorMessage :validationErrors=v$?.$errors></ValidationErrorMessage>

          <div v-if="!unitsErrorMessage" class="d-flex justify-content-center w-100 mt-5">
            <SaveButton
                :label="$t('general.button.save')"
                :loading="isSubmitting"/>
          </div>
        </form>
      </div>
    </div>
  </PageTemplate>

  <Modal
      v-model="showDigitalSignatureModal"
      title="Digitale Unterschrift"
      :hide-cancel="true"
      :button-label="$t('general.button.save')"
      sizeModal="modal-md"
      :hide-footer="true"
      classFooter="justify-content-center">
    <AssistedLivingCoachingDigitalSignatureForm
        :meetingId="firstInterviewId"
        :coachingId="coachingId"
        meetingType="firstInterview"
        v-model:missingDigitalSignature="missingDigitalSignatureForFirstInterview"
        v-model:submitForm="digitalSignatureSubmitForm"/>
  </Modal>

  <Modal
      title="Begegnungsgeschichte"
      :button-label="$t('general.button.save')"
      :customWidth="'1400px'"
      v-model="showMeetingHistoryModal"
      :hide-footer="true"
      classFooter="justify-content-center">
    <MeetingHistoryList :meetingId="firstInterviewId"/>
  </Modal>
</template>

<script setup>
import dropdownService from '@/api/Dropdown';
import portalCoachingService from '@/api/Portal/AssistedLivingCoaching';
import coachingService from '@/api/Unemployed/AssistedLivingCoaching';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import BaseNumber from '@/components/base/BaseNumber.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import Loader from '@/components/Loader.vue';
import Modal from '@/components/modal/Modal.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import Timepicker from '@/components/picker/Timepicker.vue';
import SelectVue from '@/components/SelectVue.vue';
import TextEditor from '@/components/TextEditor.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import {generatePlaceAndTypeOfCareDropdown} from '@/shared/portal/assistedLivingCoachingFunctions';
import {addDeletedCoachToDropdown} from '@/shared/portal/commonFunctions';
import {requiredRule} from '@/shared/validators/validationRules';
import {piniaEnumsStore} from '@/store/piniaEnumsStore';
import {piniaUserStore} from '@/store/piniaUserStore';
import AssistedLivingCoachingDigitalSignatureForm
  from '@/views/App/Portal/AssistedLivingCoaching/AssistedLivingCoachingDigitalSignatureForm.vue';
import CoachingOverviewData from '@/views/App/Portal/AssistedLivingCoaching/CoachingOverviewData.vue';
import AccordionItem from '@/views/App/Portal/AssistedLivingCoaching/FirstInterview/AccordionItem.vue';
import AccordionItemWithDropdown
  from '@/views/App/Portal/AssistedLivingCoaching/FirstInterview/AccordionItemWithDropdown.vue';
import CooperationPartnerAccordionItem
  from '@/views/App/Portal/AssistedLivingCoaching/FirstInterview/CooperationPartnerAccordionItem.vue';
import Menu from '@/views/App/Portal/AssistedLivingCoaching/Menu.vue';
import useVuelidate from '@vuelidate/core';
import {computed, onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import BaseToggle from "@/components/base/BaseToggle.vue";
import MeetingHistoryList from "@/views/App/Portal/AssistedLivingCoaching/MeetingHistoryList.vue";
import SaveButton from '@/components/button/SaveButton.vue';

const piniaEnumsState = piniaEnumsStore();
const piniaUserState = piniaUserStore();
const piniaCurrentUser = computed(() => piniaUserState.currentUser.user);
const getEnums = computed(() => piniaEnumsState.enums);
const currentUserRole = piniaCurrentUser.value.roles[0];

const {
  presenceTypes,
  doctorTypes,
  assistanceTypes,
  graduationTypes,
} = computed(() => piniaEnumsState.enums).value;

const {t} = useI18n();
const coachingData = ref('');
const calculatedUnitsData = ref();
const route = useRoute();
const coachingId = route.params.id;
const firstInterviewId = ref(null);
const operationType = ref('');
const presenceDropdown = ref([]);
const coachDropdown = ref([]);
const unitsErrorMessage = ref('');
const isLoaded = ref(false);
const isSubmitting = ref(false);
const isDigitalSignature = ref(false);
const showDigitalSignatureModal = ref(false);
const digitalSignatureSubmitForm = ref(false);
const isBilled = ref(false);
const isCoachBilled = ref(false);
const placeAndTypeOfCareDropdown = ref([]);
const typesOfCoachingDropdown = ref([]);
const activeAccordion = ref(1); // Tracks the currently open accordion item
const missingDigitalSignatureForFirstInterview = ref(false);
const showNumberOfClients = ref(false);
const appointmentTypeDropdown = ref([])

const updateAsAdmin = ref(false);
const updatedByAdmin = ref(false) // Need this for update as admin logic
const originalIsBilled = ref(false); // Need this for update as admin logic
const originalIsCoachBilled = ref(false); // Need this for update as admin logic
const showMeetingHistoryModal = ref(false);

const formDataRadioButtons = ref({
  targetGroup: 'mentallyDisabledPeople',
  typeOfLiving: 'singleApartment',
  housingBroker: 'noMediation',
});

const formData = ref({
  coachingId: '',
  operationType: '',
  termin: '',
  startTime: '00:00',
  endTime: '00:00',
  presence: '',
  units: 0,
  totalMinutes: 0,
  signature: false,
  billed: false,
  coachId: null,
  placeAndTypeOfCare: '',
  othersDescription: '',
  durationOfSupervision: '< 3',
  cooperationPartnerDescription: '',
  graduation: '',
  education: '',
  employmentBiography: '',
  leaveTheProfession: '',
  cooperationPartners: [],
  limitations: [],
  dependencies: [],
  medicalCares: [],
  medications: [],
  treatmentsAndAssistance: [],
  treatmentInYears: [],
  resourceAndSkills: [],
  obstacles: [],
  steps: [],
  typesOfCoaching: [],
  appointmentType: ''
});

const originalFormData = ref({});
// This key will force the Timepicker to re-create when changed
const startTimeKey = ref(formData.value.startTime);
const endTimeKey = ref(formData.value.endTime);

const formRules = ref({
  termin: requiredRule(t),
  startTime: requiredRule(t),
  endTime: requiredRule(t),
  presence: requiredRule(t),
  units: requiredRule(t),
  totalMinutes: requiredRule(t),
  placeAndTypeOfCare: requiredRule(t)
});

const computedRules = computed(() => formRules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  if (isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    formData.value.coachingId = +coachingId;
    formData.value.units = Number(formData.value.units);// or parseFloat if you prefer
    formData.value.totalMinutes = Number(formData.value.totalMinutes);

    formData.value.mentallyDisabledPeople = formDataRadioButtons.value.targetGroup === 'mentallyDisabledPeople';
    formData.value.peopleWithAddictionDisorders = formDataRadioButtons.value.targetGroup === 'peopleWithAddictionDisorders';

    formData.value.singleApartment = formDataRadioButtons.value.typeOfLiving === 'singleApartment';
    formData.value.coupleApartment = formDataRadioButtons.value.typeOfLiving === 'coupleApartment';
    formData.value.sharedApartment = formDataRadioButtons.value.typeOfLiving === 'sharedApartment';
    formData.value.inTheFamilyOfOrigin = formDataRadioButtons.value.typeOfLiving === 'inTheFamilyOfOrigin';
    formData.value.housingStyleOthers = formDataRadioButtons.value.typeOfLiving === 'housingStyleOthers';

    formData.value.noMediation = formDataRadioButtons.value.housingBroker === 'noMediation';
    formData.value.serviceProvider = formDataRadioButtons.value.housingBroker === 'serviceProvider';
    formData.value.cooperationPartner = formDataRadioButtons.value.housingBroker === 'cooperationPartner';

    if (firstInterviewId.value) {
      if (updateAsAdmin.value) {
        await portalCoachingService.updateFirstInterviewAsAdmin(
            formData.value,
            +firstInterviewId.value
        );
      } else {
        await portalCoachingService.updateFirstInterview(
            formData.value,
            +firstInterviewId.value
        );
      }
    } else {
      await portalCoachingService.createFirstInterview(formData.value);
    }

    await getFirstInterviewData(coachingId);
    await getCoachingData(coachingId);

    updateAsAdmin.value = false;
    activeAccordion.value = null;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getCoachingData(coachingId) {
  try {
    CloseToast();
    const {data} = await coachingService.getAssistedLivingCoaching(+coachingId);
    coachingData.value = data.data;
    isDigitalSignature.value = data.data.digitalSignature;
    operationType.value = data?.data?.nameOfCoaching?.operationType;

    const {data: calculatedUnits} = await coachingService.getCalculatedUnits(+coachingId);
    calculatedUnitsData.value = calculatedUnits.data;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function getFirstInterviewData(coachingId) {

  try {
    const {data} = await portalCoachingService.getFirstInterviewData(coachingId);
    const firstInterview = data?.data;

    if (firstInterview) {
      isBilled.value = firstInterview?.invoiced;
      isCoachBilled.value = firstInterview?.coachInvoiced;

      if (!firstInterview.digitalSignatureImage) {
        missingDigitalSignatureForFirstInterview.value = true;

      }
      // Save original values
      originalIsBilled.value = firstInterview.invoiced;
      originalIsCoachBilled.value = firstInterview.coachInvoiced;
      updatedByAdmin.value = firstInterview.updatedByAdmin

      const coachId = firstInterview?.coach?.id;
      const limitationsData = mapData(firstInterview?.limitations || []);
      const dependenciesData = mapData(firstInterview?.dependencies || []);
      const medicalCaresData = mapData(firstInterview?.medicalCares || []);
      const medicationsData = mapData(firstInterview?.medications || []);
      const treatmentsAndAssistanceData = mapData(firstInterview?.treatmentsAndAssistance || []);
      const treatmentInYearsData = mapData(firstInterview?.treatmentInYears || []);
      const resourceAndSkillsData = mapData(firstInterview?.resourceAndSkills || []);
      const obstaclesData = mapData(firstInterview?.obstacles || []);
      const stepsData = mapData(firstInterview?.steps || []);
      const typesOfCoachingData = mapData(firstInterview?.typesOfCoaching || []);
      const cooperationPartners = mapDataCooperationPartners(firstInterview?.cooperationPartners || []);
      formDataRadioButtons.value = firstInterview?.medicalHistoryCheckboxes || formDataRadioButtons.value;

      addDeletedCoachToDropdown(firstInterview?.coach, coachDropdown);

      firstInterviewId.value = firstInterview?.id;

      formData.value = {
        ...firstInterview,
        coachId: coachId,
        limitations: limitationsData,
        dependencies: dependenciesData,
        medicalCares: medicalCaresData,
        medications: medicationsData,
        treatmentsAndAssistance: treatmentsAndAssistanceData,
        treatmentInYears: treatmentInYearsData,
        resourceAndSkills: resourceAndSkillsData,
        obstacles: obstaclesData,
        steps: stepsData,
        typesOfCoaching: typesOfCoachingData,
        cooperationPartners: cooperationPartners,
      };

      // store original as a deep copy !!!
      originalFormData.value = JSON.parse(JSON.stringify(formData.value));
    }
  } catch (error) {
    await ErrorToast(error);
  }

}

async function getAssignedCoaches(coachingId) {
  try {
    CloseToast();
    const {data} = await dropdownService.getAssistedLivingCoachingAssignedCoaches(+coachingId);
    coachDropdown.value = data.data.map(item => ({
      label: `${item.firstName}` + ' ' + `${item.lastName}`,
      value: item?.id,
    }));
  } catch (error) {
    await ErrorToast(error);
  }
}

// Accordion
const toggleAccordion = (index) => {
  activeAccordion.value = activeAccordion.value === index ? null : index;
};

const addItem = (type, newItem) => {
  formData.value[type].push(newItem);
};

const removeItem = (type, index) => {
  formData.value[type].splice(index, 1);
};

const calculateTimeDifference = () => {
  if (formData.value.startTime && formData.value.endTime) {
    const [startHours, startMinutes] = formData.value.startTime.split(':').map(Number);
    const [endHours, endMinutes] = formData.value.endTime.split(':').map(Number);
    const startTotalMinutes = startHours * 60 + startMinutes;
    const endTotalMinutes = endHours * 60 + endMinutes;
    const diffMinutes = endTotalMinutes - startTotalMinutes;
    const unitDuration = 50;
    let units = (diffMinutes / unitDuration).toPrecision(3).substring(0, 4);

    onChangeUnits(units);

    // if (units > 0) {
    //   if (diffMinutes % 10 === 0) {
    //     unitsErrorMessage.value = '';
    //   } else {
    //     unitsErrorMessage.value = 'Abrechnung nur in 10-Minuten-Blöcken möglich.';
    //   }
    // }

    formData.value.units = Number(units).toFixed(2);
    formData.value.totalMinutes = diffMinutes;
  } else {
    formData.value.units = 0;
    formData.value.totalMinutes = 0;
  }
};

function onChangeUnits(value) {
  // Parse value to a float
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue) || parsedValue <= 0) {
    unitsErrorMessage.value = 'Einheiten müssen runde Zahlen sein, die größer als 0 sind.';
  } else {
    unitsErrorMessage.value = '';
  }
}

watch(
    () => [
      formData.value.startTime,
      formData.value.endTime,
      formData.value.presence,
    ],
    calculateTimeDifference,
);

watch(
    () => formDataRadioButtons.value.typeOfLiving,
    (newValue) => {
      if (formDataRadioButtons.value.typeOfLiving === 'housingStyleOthers') {
        formRules.value = {...formRules.value, othersDescription: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, othersDescription: ''};
      }
    },
);

watch(
    () => formDataRadioButtons.value.housingBroker,
    (newValue) => {
      if (formDataRadioButtons.value.housingBroker === 'cooperationPartner') {
        formRules.value = {...formRules.value, cooperationPartnerDescription: requiredRule(t)};
      } else {
        formRules.value = {...formRules.value, cooperationPartnerDescription: ''};
      }
    },
);

async function getEnumsDropdown() {
  presenceDropdown.value = (presenceTypes || []).filter(
      type => type.value === 'anwesend' || type.value === 'unentschuldigt',
  );
  appointmentTypeDropdown.value = getEnums.value.assistedLivingCoachingAppointmentTypes
}

const mapData = (data, fields = ['id', 'title', 'description']) => {
  return data.map(item => {
    let mappedItem = {};
    fields.forEach(field => {
      mappedItem[field] = item[field] ?? null;
    });
    return mappedItem;
  });
};

const mapDataCooperationPartners = (data, fields = ['id', 'year', 'description']) => {
  return data.map(item => {
    let mappedItem = {};
    fields.forEach(field => {
      mappedItem[field] = item[field] ?? null;
    });
    return mappedItem;
  });
};

const labelStyle = computed(() => {
  return unitsErrorMessage.value ? {color: 'red'} : {};
});

function handleDigitalSignatureModal() {
  CloseToast();
  showDigitalSignatureModal.value = true;
}

watch(digitalSignatureSubmitForm, () => {
  showDigitalSignatureModal.value = false;
});

function onUpdateAppointmentType(value) {
  if (value === 'group') {
    showNumberOfClients.value = true
  } else {
    showNumberOfClients.value = false
  }
}

function onChangeUpdateAsAdmin() {
  if (updateAsAdmin.value) {
    isBilled.value = false;
    isCoachBilled.value = false;
  } else {
    // restore form data from original snapshot
    formData.value = JSON.parse(JSON.stringify(originalFormData.value));

    formData.value.startTime = originalFormData.value.startTime;
    startTimeKey.value = originalFormData.value.startTime + '_' + Date.now(); // Change the key to force re-render

    formData.value.endTime = originalFormData.value.endTime;
    endTimeKey.value = originalFormData.value.endTime + '_' + Date.now(); // Change the key to force re-render

    isBilled.value = originalIsBilled.value;
    isCoachBilled.value = originalIsCoachBilled.value;
  }
}

const showUpdateAsAdminButton = computed(() =>
    (currentUserRole === 'ROLE_ADMIN' || currentUserRole === 'ROLE_ACCOUNTANT') &&
    (originalIsBilled.value || originalIsCoachBilled.value)
);

function handleMeetingHistoryModal() {
  CloseToast();
  showMeetingHistoryModal.value = true;
  showDigitalSignatureModal.value = false;
}

const minutesArray = [
  '00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11',
  '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23',
  '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35',
  '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47',
  '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59',
];

onMounted(async () => {
  await Promise.all([
    getCoachingData(coachingId),
    getFirstInterviewData(coachingId),
    getAssignedCoaches(coachingId),
    getEnumsDropdown(),
    typesOfCoachingDropdown.value = getEnums?.value?.typesOfCoaching || [],
    placeAndTypeOfCareDropdown.value = generatePlaceAndTypeOfCareDropdown()
  ]);

  onUpdateAppointmentType(formData.value.appointmentType)

  isLoaded.value = true;
});
</script>

<style scoped>
</style>